export default "__VITE_ASSET__cpxtkCls__"